// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataPriceTarget_main__Av5C7"};